import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AuthService } from "@app/core/services/auth/auth.service";

@NgModule({
  imports: [HttpClientModule],
  providers: [AuthService],
})
export class AuthModule {}
